import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild, ViewChildren, QueryList, Input, Output, EventEmitter, SimpleChanges, NgZone } from '@angular/core';
import { UtilsService } from 'src/app/core/services/utils/utils.service';
import { RequestCreationService } from 'src/app/core/services/request-creation/request-creation.service';
import { FlawDetail } from 'src/app/models/flaw-detail.model';
import { IonInfiniteScroll } from '@ionic/angular';
import { Keyboard } from '@awesome-cordova-plugins/keyboard/ngx';
import { Skeleton } from 'src/app/models/skeleton.model';
import { ItemSpot } from 'src/app/models/item-spot.model';

@Component({
  selector: 'cc-failures-detail-list',
  templateUrl: './failures-detail-list.component.html',
  styleUrls: ['./failures-detail-list.component.scss'],
})
export class FailuresDetailListComponent implements OnInit {

  public failureDetails: FlawDetail[] = [];
  public list: Array<any> = [];
  private nextPage: number = 1;
  private searchParam: string = '';
  public total: number;
  public httpError: string = null;
  public showLoader: boolean = false;

  public selectedArray: Array<number> = [];


  public skeleton: Skeleton = {
    show: true
  }
  private unitParams;

  @ViewChild(IonInfiniteScroll, { static: false }) infiniteScroll: IonInfiniteScroll;
  @ViewChildren('flawDetails') query: QueryList<any>;

  @Input() itemSpot: ItemSpot;
  @Input() enclosureId: number;
  @Input() company: string = '';
  @Output() selected = new EventEmitter<any>();

  constructor(
    private requestCreationService: RequestCreationService,
    private utils: UtilsService,
    private keyboard: Keyboard,
    private ngZone: NgZone,
    private translate : TranslateService
  ) { }

  async ngOnInit() {
    this.unitParams = await this.utils.getFromStorage('unitParams');
    if (this.itemSpot && this.enclosureId) {
      this.skeleton.show = true;
      this.getFailureDetail();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.itemSpot && !changes.itemSpot.isFirstChange()) {
      this.selectedArray = [];
      this.failureDetails = [];
      this.skeleton.show = true;
      this.nextPage = 1;
      this.getFailureDetail();
    }
  }

  async getFailureDetail(ev?, search?) {
    if (search) {
      this.showLoader = true;
    }
    this.requestCreationService.getFailureDetailByEnclosureSpotItem(this.company, this.enclosureId, this.itemSpot.lugar.id, this.itemSpot.item.id, this.nextPage, this.unitParams, search)
      .subscribe(async ({ data, current_page, total, error, operation }: { data: FlawDetail[], current_page: number, total: number, error, operation: string }) => {
        this.showLoader = false;
        this.skeleton.show = false;
        if (error) {
          this.httpError = operation;
          this.utils.showMessage(operation);
        } else {
          this.httpError = null;
          this.ngZone.run(() => {
            this.failureDetails = [...this.failureDetails, ...data.map(el => {
              el.checked = this.selectedArray.find(selected => selected === el.id) ? true : false;
              return el;
            })];
            setTimeout(() => {
              this.utils.updateSlide.emit();
            }, 100);
          });

          this.total = total;
        }

        if (ev) {
          ev.target.complete();
          if (this.failureDetails.length == total)
            ev.target.disabled = true;
        }

      });
  }


  search({ detail: { value } }) {
    this.nextPage = 1;
    if (value.length > 1) {
      this.failureDetails = [];
      this.getFailureDetail(null, value);
      this.searchParam = value;
    } else if (value.length === 0) {
      this.cleanSearch();
    }
  }

  cleanSearch() {
    this.keyboard.hide();
    this.failureDetails = [];
    this.searchParam = '';
    this.skeleton.show = true;
    this.getFailureDetail();
  }


  loadMore(ev) {
    this.nextPage++;
    if (this.searchParam) {
      this.getFailureDetail(ev, this.searchParam);
    }
    else
      this.getFailureDetail(ev);
  }

  add() {
    const selectedDetails = [];

    for (const iterator of this.selectedArray) {
      selectedDetails.push(this.failureDetails.find((el: FlawDetail) => el.id === iterator));
    }

    if (!selectedDetails.length)
      this.utils.showMessage(this.translate.instant('failures-detail-list.Debe seleccionar al menos un detalle de falla'));
    else {
      this.selected.emit(selectedDetails);
    }
  }

  selectDetail({ detail }) {
    if (detail.checked)
      this.selectedArray.push(parseInt(detail.value));
    else
      this.selectedArray.splice(this.selectedArray.findIndex(el => el === parseInt(detail.value)), 1);

    this.failureDetails[this.failureDetails.findIndex(el => el.id === parseInt(detail.value))].checked = detail.checked;
  }

}
